import i18next from 'i18next';

i18next.addResources('es_CL', 'PurchaseFailure', {
  title: 'Tu pago ha sido rechazado',
  message: 'Hubo un problema técnico con tu pago, por favor inténtalo de nuevo.',
  button: 'Volver a intentar'
});
